






























































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { BrazeWebhookDto } from "@/store/braze-webhooks/braze-webhook.interface";
import dayjs from "dayjs";
import ConfirmModal from "@/components/modal/Confirm.vue";

@Component
export default class AppWebhookForm extends Vue {
  @Prop() data: BrazeWebhookDto;
  @Prop({ default: false }) loading: boolean;
  @Prop({ default: false }) disabled: boolean;

  form: any = {};

  @Emit("onSubmit")
  async onSubmit() {
    return {
      ...this.form,
      is_active: this.form.is_active ? true : false,
      tags: (this.form.tags || []).map((item: any) => {
        if (typeof item === "object") {
          return item.name;
        }
        return item;
      })
    };
  }

  @Emit("onCancel")
  async onCancel() {}

  @Emit("onEditable")
  async onEditable() {}

  reset() {
    this.form = {
      name: ""
    };
  }

  @Watch("data", { immediate: true, deep: true })
  onDataChange(data: BrazeWebhookDto, oldData: BrazeWebhookDto) {
    const today = dayjs().format("YYYY-MM-DD");
    this.form = data
      ? {
          ...data
        }
      : {};
  }

  async onRemove() {
    return (this.$refs.confirmModal as ConfirmModal).open();
  }

  @Emit("onRemove")
  async onConfirmRemove() {
    return true;
  }
}
